import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const SuspendedIcon = ({ className }) => (
  <SvgIcon viewBox='0 0 16 16' className={className}>
    <g id='Group_2214' data-name='Group 2214' transform='translate(-47 -302)'>
      <g
        id='Ellipse_29'
        data-name='Ellipse 29'
        transform='translate(47 302)'
        fill='#f4373e'
        stroke='#fafbfc'
        strokeWidth='1'
      >
        <circle cx='8' cy='8' r='8' stroke='none' />
        <circle cx='8' cy='8' r='7.5' fill='none' />
      </g>
      <path
        id='Path_12587'
        data-name='Path 12587'
        d='M14705.482,9316.87l-5.191,5.207'
        transform='translate(-14647.906 -9009.42)'
        fill='none'
        stroke='#fff'
        strokeLinecap='round'
        strokeWidth='1'
      />
      <path
        id='Path_12590'
        data-name='Path 12590'
        d='M14700.291,9316.87l5.191,5.207'
        transform='translate(-14647.906 -9009.42)'
        fill='none'
        stroke='#fff'
        strokeLinecap='round'
        strokeWidth='1'
      />
    </g>
  </SvgIcon>
);

export default SuspendedIcon;
